import React, { useRef } from "react";
import "@css/news/searchfour.css";
import contact from "@images/contact.png";
import vs from "@images/2viewstation_logo.svg";
import analy from '../assets/images/analy/analy.svg';
import euci from "@images/euci.svg";
import beamer from '@images/codebeamer-black.png';
import { useState, useEffect } from "react";
import { getContact, getAnaly, getVs, getBeamer, getEuci, getAllnews } from "../utils";
import { Link } from "react-router-dom";
import loading from "@images/loading.png";
import { LeftOutlined, RightOutlined } from '@ant-design/icons'


// const winUrl = window.location.href;
// const winUrlSplit = winUrl.split('/')[3];
// console.log(winUrlSplit);
const Searchfour = () => {
  const [msg, setMsg] = useState("");
  const [current, setCurrent] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [contactText, setContact] = useState([]);
  const [analyText, setAnalyText] = useState([]);
  const [vsText, setVs] = useState([]);
  const [codebeamer, setCodebeamer] = useState([]);
  const [euciText, setEuci] = useState([]);
  const [allnews, setAllnews] = useState([]);
  const [load, setLoad] = useState("");
  const [winUrlSplit, setWinUrlSplit] = useState('');
  const sliderRef = useRef(null);
  const sliderContainerRef = useRef(null);
  const [hasMoreData, setHasMoreData] = useState(true); // 是否还有更多数据

  useEffect(() => {
    const winUrl = window.location.pathname;
    const winUrlSplita = winUrl.split('/')[1];
    setWinUrlSplit(winUrlSplita)
  }, [window.location])

  const [showLogo, setShowLogo] = useState([
    { img: contact, check: 0, id: 0 },
    // { img: analy, check: 0, id: 1 },
    { img: vs, check: 0, id: 1 },
    { img: beamer, check: 0, id: 2 },
    { img: euci, check: 0, id: 3 }
  ]);
  const showLogos = [
    { img: contact, check: 0, id: 0 },
    // { img: analy, check: 0, id: 1 },
    { img: vs, check: 0, id: 1 },
    { img: beamer, check: 0, id: 2 },
    { img: euci, check: 0, id: 3 }
  ];
  const onClickshow = (currentItem) => {
    const { id, check } = currentItem;
    const news = showLogos;
    news.forEach((item) => {
      if (item.id === id) {
        item.check = !check;
        setShowLogo(news);
        if (item.check === false) {
          setCurrent("");
        } else if (item.check === true) {
          setCurrent(id);
        }
      }
    });
    setPageIndex(1);
  };
  const checkNews = () => {
    if (current === 0) {
      return contactText;
    } 
    // else if (current === 1) {
    //   return analyText;
    // } 
    else if (current === 1) {
      return vsText;
    } else if (current === 2) {
      return codebeamer;
    } else if (current === 3) {
      return euciText;
    } else if (current === "") {
      return allnews;
    }
  };

  // **********************
  const onclickMore = (i) => {
    setPageIndex(i);
    // console.log(pageIndex);
  };

  const onclickBread = (i) => {
    localStorage.setItem("route", "news");
  };
  const getList = () => {
    setLoad(false);
    let hasMore = false;
    if (current === 0) {
      getContact(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setContact(res.Data);
            } else {
              setContact(() => {
                contactText.push(...res.Data);
                return [...contactText];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } 
    // else if (current === 1) {
    //   getAnaly(pageIndex)
    //     .then((res) => {
    //       if (!res.Message) {
    //         if (pageIndex === 1) {
    //           setAnalyText(res.Data);
    //         } else {
    //           setAnalyText(() => {
    //             analyText.push(...res.Data);
    //             return [...analyText];
    //           });
    //         }
    //         hasMore = res.Data.length > 0;
    //       }
    //     })
    //     .finally(() => {
    //       setLoad(true);
    //       setHasMoreData(hasMore);
    //     });
    // } 
    else if (current === 1) {
      getVs(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setVs(res.Data);
            } else {
              setVs(() => {
                vsText.push(...res.Data);
                return [...vsText];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } else if (current === 2) {
      getBeamer(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setCodebeamer(res.Data);
            } else {
              setCodebeamer(() => {
                codebeamer.push(...res.Data);
                return [...codebeamer];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } else if (current === 3) {
      getEuci(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setEuci(res.Data);
            } else {
              setEuci(() => {
                euciText.push(...res.Data);
                return [...euciText];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    } else if (current === "") {
      getAllnews(pageIndex)
        .then((res) => {
          if (!res.Message) {
            if (pageIndex === 1) {
              setAllnews(res.Data);
            } else {
              setAllnews(() => {
                allnews.push(...res.Data);
                return [...allnews];
              });
            }
            hasMore = res.Data.length > 0;
          }
        })
        .finally(() => {
          setLoad(true);
          setHasMoreData(hasMore);
        });
    }
  };
  
  useEffect(() => {
    getList();
  }, [current, pageIndex, showLogo, msg]);

  const handleScrollLeft = () => {
    sliderContainerRef.current.scrollLeft -= sliderRef.current.offsetWidth;
  };

  const handleScrollRight = () => {
    sliderContainerRef.current.scrollLeft += sliderRef.current.offsetWidth;
  };
  return (
    <div className="sear_big flex">
      <div className="sear_check flex">
      {document.body.clientWidth < 1000 && (
        <div>
          <LeftOutlined
            className="icon-left"
            onClick={handleScrollLeft}
          />
        </div>
        )}
        {/* <div className="check"></div> */}
        <div className="sear_check_center">
          <div className="slide-contain" ref={sliderContainerRef}>
            <div className="container-flex" ref={sliderRef}>
              {showLogo.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => onClickshow(item)}
                    className={item.check ? "search_background" : "search_img"}
                  >
                    <img src={item.img} alt="" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {document.body.clientWidth < 1000 && (
          <div className='long-icon right'>
            <RightOutlined
              className="icon-right"
              onClick={handleScrollRight}
            />
          </div> 
        )}
      </div>
      <div className="sear_four">
        {load ? (
          <>
            {checkNews().length > 0 ? (
              <div className="sear_four_text">
                {checkNews().map((item, i) => {
                  return (
                    <div key={i}>
                      <Link to={`/detail/${item.Id}?type=${winUrlSplit}`} target="_blank" className="link-container">
                        <img src={item.FullThumbImage} alt="" />
                        <div className="sear_four_text_box">
                          <h1>{item.NewsTitle}</h1>
                          <p>{item.NewsDesc}</p>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="sear-p">暂无数据</p> // 如果没有数据，则显示“暂无数据”
            )}
            {hasMoreData && checkNews().length > 0 && (
              <button onClick={() => onclickMore(pageIndex + 1)}>
                {load ? "加载更多" : "加载中..."}
              </button>
            )}
          </>
        ) : (
          <div className="sear_loading">
            <img src={loading} alt="" />
            <p>加载中...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Searchfour;
